import { render, staticRenderFns } from "./file.vue?vue&type=template&id=99256720&scoped=true"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"
import style0 from "./file.vue?vue&type=style&index=0&id=99256720&prod&lang=stylus"
import style1 from "./file.vue?vue&type=style&index=1&id=99256720&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99256720",
  null
  
)

export default component.exports